import { render } from "./JiffyServicesPreview.vue?vue&type=template&id=0010a94a&scoped=true"
import script from "./JiffyServicesPreview.vue?vue&type=script&lang=js"
export * from "./JiffyServicesPreview.vue?vue&type=script&lang=js"

import "./JiffyServicesPreview.vue?vue&type=style&index=0&id=0010a94a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0010a94a"]])

export default __exports__